"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spanishTranslation = {
    personalizeTitle: 'Personalización',
    personalizePopoverButtonLabel: '¿Necesitas más información?',
    personalizeButtonText: 'Personalizar',
    personalizePopoverText: 'La personalización se aplica a la cantidad seleccionada',
    personalizeAnotherButtonText: 'Personalizar otro',
    personalizeAnotherPopoverText: 'Duplicar este producto con diferente personalización',
    personalizeAddAgainButtonText: 'Añadir artículo nuevamente',
    personalizeAddAgainPopoverText: 'Duplicar este producto sin personalizar',
    personalizeShippingLabel: 'Datos de envio',
    personalizeStyleLabel: 'Tipo de letra',
    personalizeFontStyleLabel: 'Nombre de la fuente',
    personalizeScriptLabel: 'Cursiva',
    personalizeBlockLabel: 'Negrilla',
    personalizeTextLabel: 'Texto',
    personalizeLine1Label: 'Línea 1',
    personalizeLine2Label: 'Línea 2',
    personalizeOptionalLabel: 'opcional',
    personalizeDifferentText: '¿Quieres esta Biblia con un nombre diferente?',
    personalizeUnitPriceLabel: 'Precio Unitario',
    personalizeRemoveLink: 'Eliminar',
    personalizeEditLink: 'Editar',
    personalizeModalTitle: 'Personaliza tu Biblia',
    personalizeModalCloseButtonLabel: 'Cerrar',
    personalizeModalPriceNote: '$6.99 por artículo. Se aplica a la cantidad seleccionada.',
    personalizeModalDisclaimerLabel: 'Aviso legal',
    personalizeModalDisclaimerText: 'Los artículos personalizados no se pueden devolver ni reembolsar. Las fuentes que se muestran son una representación general y pueden variar. El color se seleccionará automáticamente para la mejor combinación.',
    personalizeModalDisclaimerAgreeLabel: 'Acepto términos del presente aviso legal.*',
    personalizeModalRequireLabel: '* campo requerido',
    personalizeModalConfirmButtonText: 'Confirmar Personalización',
};
exports.default = spanishTranslation;
